export default __webpack_public_path__ + "static/media/image33tum.b9ca546d.jpg";